<template>
  <div class="flex items-baseline mb-4 sm:flex-col sm:items-start">
    <label
      v-if="label"
      :class="labelClass"
      class="flex-shrink-0 mt-[5px] sm:mb-1 text-gray-500 weiby-label-width"
    >
      {{ label }}<span v-if="required" class="text-red-500">*</span>
    </label>
    <div class="flex flex-col w-full">
      <div class="relative w-full">
        <t-input
          :autocomplete="autocomplete"
          :class="{ 'pr-8': passwordReveal || showError || showSuccess }"
          :disabled="disabled"
          :placeholder="placeholder"
          :maxlength="max"
          :type="currentType"
          :value="value"
          :variant="getVariant"
          class="w-full"
          v-bind="$attrs"
          v-on="$listeners"
          @input="$emit('input', $event)"
        />
        <i
          v-if="passwordReveal"
          :class="[
            iconDefaultClass,
            { 'icon-eye-open': !show, 'icon-eye-close': show },
          ]"
          class="text-xl"
          @click="show = !show"
        />
        <i
          v-else-if="showError"
          :class="[iconDefaultClass]"
          class="icon-alert-circle"
        />
        <i
          v-else-if="showSuccess"
          :class="[iconDefaultClass]"
          class="icon-success-circle"
        />
      </div>
      <section
        v-if="message || showCount"
        :class="{ 'justify-end': !message && showCount }"
        class="flex"
      >
        <span
          v-if="message"
          :class="{ 'text-red-500': showError }"
          class="mt-1 text-gray-500 text-sm"
        >
          {{ message }}
        </span>
        <span v-if="showCount && textCount" class="flex-shrink-0 ml-2 text-gray-300 text-xs">
          {{ textCount }}
          <span v-if="max"> / {{ max }}</span>
        </span>
      </section>
    </div>
  </div>
</template>

<script>
import WInput from './WInput';

export default WInput;
</script>

<style lang="scss" scoped>
@import 'WInput';
</style>
